import {
  DirectionalHint,
  ITooltipProps,
  IconButton,
  Label,
  Spinner,
  SpinnerSize,
  Text,
  TooltipDelay,
  TooltipHost,
} from '@fluentui/react';
import * as React from 'react';
import * as Styled from '../Styles/labels.styled';

export const DisplayRequiredLabel = (labelName: string, toolTipContentsProps: ITooltipProps) => {
  return (
    <Styled.LabelContainer>
      <Label>{labelName}</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={toolTipContentsProps}
      >
        <IconButton
          iconProps={{ iconName: 'Info' }}
          aria-label={'Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};

export function DisplayNonRequiredLabel(labelName: string, toolTipContentsProps: ITooltipProps) {
  return (
    <Styled.LabelContainer>
      <Label>{labelName}</Label>
      <TooltipHost
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={toolTipContentsProps}
      >
        <IconButton
          iconProps={{ iconName: 'Info' }}
          aria-label={'Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
}

const spnClientIdTooltipProps: ITooltipProps = {
  onRenderContent: () => (
    <Styled.CustomTooltipContainer>
      <Text>AAD Client ID that the consumer will use to access HRDP data.</Text>
    </Styled.CustomTooltipContainer>
  ),
};

const msiObjectIdTooltipProps: ITooltipProps = {
  onRenderContent: () => (
    <Styled.CustomTooltipContainer>
      <Text>Managed Identity Object ID that the consumer will use to access HRDP data.</Text>
    </Styled.CustomTooltipContainer>
  ),
};

export const onRenderSpnIdLabel = () => {//isClientIdInfoLoading: boolean) => {
  return (
    <Styled.LabelContainer>
      <Label>SPN Client ID</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'spnClientIdTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={spnClientIdTooltipProps}
      >
        <IconButton
          id={'spnClientIdIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'SPN Client ID Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
      {/*isClientIdInfoLoading && (
        <Styled.LabelLoadingContainer>
          <Spinner size={SpinnerSize.small} />
        </Styled.LabelLoadingContainer>
      )*/}
    </Styled.LabelContainer>
  );
};

export const onRenderMsiObjectIdLabel = () => { //isMsiObjectIdInfoLoading: boolean) => {
  return (
    <Styled.LabelContainer>
      <Label>MSI Object ID</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'msiObjectIdTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={msiObjectIdTooltipProps}
      >
        <IconButton
          id={'msiObjectIdIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'MSI Object ID Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
      {/*isMsiObjectIdInfoLoading && (
        <Styled.LabelLoadingContainer>
          <Spinner size={SpinnerSize.small} />
        </Styled.LabelLoadingContainer>
      )*/}
    </Styled.LabelContainer>
  );
};

const serviceTreeIdTooltipProps: ITooltipProps = {
  onRenderContent: () => (
    <Styled.CustomTooltipContainer>
      <Text>
        The Service Tree ID of your service from the aka.ms/serviceTree portal should be provided. <br/>
        Note that only members of the "Service Tree Feature Team alias" will have access to view/create requests for the service. <br/> 
        If you encounter error, ensure you have access by navigate to aka.ms/serviceTree portal, select "Your Service," and then go to the "Metadata" tab to find the Feature Team alias field. This field can be populated with individual aliases or team security groups separated by commas.
      </Text>
    </Styled.CustomTooltipContainer>
  ),
};

export const onRenderServiceTreeIdLabel = (isServiceTreeInfoLoading: boolean) => {
  return (
    <Styled.CustomLabelContainer>
      <Label>Service Tree ID</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'serviceTreeIdTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={serviceTreeIdTooltipProps}
      >
        <IconButton
          id={'serviceTreeIdIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Service Tree ID Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
      {isServiceTreeInfoLoading && (
        <Styled.LabelLoadingContainer>
          <Spinner size={SpinnerSize.small} />
        </Styled.LabelLoadingContainer>
      )}
    </Styled.CustomLabelContainer>
  );
};

const serviceBusNamespaceTooltipProps: ITooltipProps = {
  onRenderContent: () => (
    <Styled.CustomTooltipContainer>
      <Text>Service Bus Configuration</Text>
    </Styled.CustomTooltipContainer>
  ),
};

export const onRenderLabelServiceBusNamespace = () => {
  return (
    <Styled.LabelContainer>
      <Label>Service Bus Namespace</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'serviceBusNamespaceTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={serviceBusNamespaceTooltipProps}
      >
        <IconButton
          id={'serviceBusNamespaceIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Service Bus Namespace Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};

const serviceBusTopicTooltipProps: ITooltipProps = {
  onRenderContent: () => (
    <Styled.CustomTooltipContainer>
      <Text>Service Bus Configuration</Text>
    </Styled.CustomTooltipContainer>
  ),
};

export const onRenderLabelServiceBusTopic = () => {
  return (
    <Styled.LabelContainer>
      <Label>Service Bus Topic</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'serviceBusTopicTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={serviceBusTopicTooltipProps}
      >
        <IconButton
          id={'serviceBusTopicIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Service Bus Topic Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};

const egressOptionsTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>Available methods of egression of HRDP data:</Text>
        <Text>1. API</Text>
        <Text>2. Service Bus</Text>
        <Text>3. DataLake</Text>
        <Text>4. GraphQL API</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

const graphEgressOptionsTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>Available methods of graph egression of HRDP data:</Text>
        <Text>1. GraphQL Application</Text>
        <Text>2. GraphQL Delegated</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const onRenderLabelEgressOptions = () => {
  return (
    <Styled.LabelContainer>
      <Label>Other Egress Options</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'egressOptionsTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={egressOptionsTooltipProps}
      >
        <IconButton
          id={'egressOptionsIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Egress Options Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};

export const onRenderLabelGraphEgressOptions = () => {
  return (
    <Styled.LabelContainer>
      <Label>Graph Egress Options</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'graphEgressOptionsTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={graphEgressOptionsTooltipProps}
      >
        <IconButton
          id={'graphEgressOptionsIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Grapg Egress Options Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};

const effectiveDatedCdmTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>For CDMs that support date effectiveness (Type 2), this option supports the following data modes:</Text>
        <Text>1. Evaluated (Single instance of current values)</Text>
        <Text>2. Fullset (Array of Back, Current, and Future Dated)</Text>
        <Text>
          <b>*Note:</b> Date effectiveness egression not supported in current version
        </Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

const accessTypeTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>This Access type field provides client authentication mode</Text>
        <Text>1. MSI Object ID (Managed Identity)</Text>
        <Text>2. SPN Client ID (Service Principal)</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const onRenderLabelEffectiveDatedCdm = () => {
  return (
    <Styled.LabelContainer>
      <Label>Effective-Dated CDM</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'effectiveDatedCdmTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={effectiveDatedCdmTooltipProps}
      >
        <IconButton
          id={'effectiveDatedCdmIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Effective Dated CDM Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};

const privacyApprovalArtifactsTooltipProps: ITooltipProps = {
  onRenderContent: () => (
    <Styled.CustomTooltipContainer>
      <Text>
        Privacy Approval Artifact(s) are required for Production app access. Acceptable file extensions .pdf, .docx,
        .msg, .png, and .jpg.
      </Text>
    </Styled.CustomTooltipContainer>
  ),
};

export const onRenderLabelPrivacyApprovalArtifacts = () => {
  return (
    <Styled.CustomLabelContainer>
      <Label>Privacy Approval Artifact(s)</Label>
      <TooltipHost
        id={'privacyApprovalArtifactsTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={privacyApprovalArtifactsTooltipProps}
      >
        <IconButton
          id={'privacyApprovalArtifactsIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Privacy Approval Artifacts Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.CustomLabelContainer>
  );
};

const privacyApprovalDateTooltipProps: ITooltipProps = {
  onRenderContent: () => (
    <Styled.CustomTooltipContainer>
      <Text>Date that the privacy review was approved.</Text>
    </Styled.CustomTooltipContainer>
  ),
};

export const onRenderLabelPrivacyApprovalDate = () => {
  return (
    <Styled.CustomLabelContainer>
      <Label>Privacy Approval Date</Label>
      <TooltipHost
        id={'privacyApprovalDateTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={privacyApprovalDateTooltipProps}
      >
        <IconButton
          id={'privacyApprovalDateIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Privacy Approval Date Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.CustomLabelContainer>
  );
};

const schemaTooltipProps: ITooltipProps = {
  onRenderContent: () => (
    <Styled.CustomTooltipContainer>
      <Text>The schema for the CDM definition.</Text>
    </Styled.CustomTooltipContainer>
  ),
};

export const onRenderLabelSchema = () => {
  return (
    <Styled.LabelContainer>
      <Label>Schema</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'schemaTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={schemaTooltipProps}
      >
        <IconButton
          id={'schemaIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Schema Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};

export const onRenderLabelSelectExistingCdm = (isApprovedCdmListLoading: boolean) => {
  return (
    <Styled.SelectExistingLabelContainer>
      <Label required={true}>Select existing CDM</Label>
      {isApprovedCdmListLoading && <Spinner size={SpinnerSize.small} />}
    </Styled.SelectExistingLabelContainer>
  );
};

export const onRenderAccessTypeLabel = () => {
  return (
    <Styled.LabelContainer>
      <Label>Access Type</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'accessTypeTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={accessTypeTooltipProps}
      >
        <IconButton
          id={'accessTypeIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Access Type Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};

export const onRenderEnvironmentsLabel = () => {
  return (
    <Styled.LabelContainer>
      <Label>Environments</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'environmentsTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={accessTypeTooltipProps}
      >
        <IconButton
          id={'environmentsIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          aria-label={'Environments Information Icon'}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};

const privacyTeamTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>Select the Privacy Team Name that applies to your request.</Text>
        <Text>If your team isn't listed, select "Other" to enter it manually.</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const onRenderLabelPrivacyTeam = () => {
  return (
    <Styled.LabelContainer>
      <Label>Authorized Privacy Team</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'privacyTeamTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={privacyTeamTooltipProps}
      >
        <IconButton
          id={'privacyTeamIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};

const otherPrivacyTeamTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>Please enter the Privacy Team Name that applies to your request.</Text>
        {/* <Text>If your team isn't listed, select "Other" to enter it manually.</Text> */}
      </Styled.CustomTooltipContainer>
    );
  },
};

export const onRenderLabelOtherPrivacyTeam = () => {
  return (
    <Styled.LabelContainer>
      <Label>Other Privacy Team</Label>
      <Styled.CustomRequiredLabel>*</Styled.CustomRequiredLabel>
      <TooltipHost
        id={'otherPrivacyTeamTooltipId'}
        directionalHint={DirectionalHint.rightCenter}
        closeDelay={TooltipDelay.zero}
        styles={Styled.TooltipHostStyles}
        tooltipProps={otherPrivacyTeamTooltipProps}
      >
        <IconButton
          id={'otherPrivacyTeamIconButtonId'}
          iconProps={{ iconName: 'Info' }}
          styles={{ root: { marginBottom: -3 } }}
        />
      </TooltipHost>
    </Styled.LabelContainer>
  );
};